var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalServicios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2.3 TotalServicios") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Dashboard",
    transform: "translate(-865.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(845.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.3-TotalServicios",
    transform: "translate(20.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.31,
    fill: "#76E09A",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(11.000000, 11.000000)",
    stroke: "#76E09A",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3248125,6.16739045 L11.3492894,8.24200553 C11.4015989,8.34958547 11.504244,8.42360837 11.6216936,8.44137386 L13.9124556,8.77398342 C14.2095341,8.81642321 14.3289578,9.18258981 14.1128109,9.39281484 L12.4566719,11.007501 C12.3708054,11.0913936 12.3313265,11.2118042 12.3520529,11.3292538 L12.7428938,13.6101461 C12.7942163,13.9062377 12.4823332,14.1322542 12.2158508,13.9921042 L10.1678839,12.9153178 C10.0622779,12.8600474 9.93594552,12.8600474 9.83033952,12.9153178 L7.78237268,13.9921042 C7.51589025,14.1322542 7.20499408,13.9062377 7.25532965,13.6101461 L7.64715752,11.3292538 C7.66689696,11.2118042 7.62840505,11.0913936 7.54253849,11.007501 L5.88541255,9.39281484 C5.67025266,9.18258981 5.7886893,8.81642321 6.08675484,8.77398342 L8.37652981,8.44137386 C8.49496644,8.42360837 8.59662456,8.34958547 8.64992104,8.24200553 L9.67341098,6.16739045 C9.80665219,5.8979471 10.1915713,5.8979471 10.3248125,6.16739045 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.999013,10 C19.999013,15.5230951 15.5221082,20 9.99901303,20 C4.47690486,20 0,15.5230951 0,10 C0,4.47690486 4.47690486,0 9.99901303,0 C15.5221082,0 19.999013,4.47690486 19.999013,10 Z",
    id: "Stroke-3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalServicios);
export default __webpack_public_path__ + "static/media/TotalServicios.1e1cdd6dbe04a244da0e3ddc162c9f29.svg";
export { ForwardRef as ReactComponent };